// @flow
/* global window */
import type { MetricTypes } from 'types/FlyerTypes'

import * as React from 'react'
import { withRouter } from 'react-router-dom'

import type { Match } from 'react-router-dom'
import * as Metric from 'models/metrics'
import moment from 'moment'

const getDisplayName = (Component: React.ComponentType<any>) =>
  Component.displayName || Component.name || 'Component'

const withMetricClick = (metric: ?MetricTypes, featureId) => (
  WrappedComponent: React.ComponentType<any>
) => {
  type Props = {
    match: Match,
    location: any,
    history: any,
    onClick?: ?Function
  }

  class WithMetricClick extends React.Component<Props> {
    onClick = (): void => {
      this.handleMetricClick()
      if (typeof this.props.onClick === 'function') {
        this.props.onClick()
      }
    }

    handleMetricClick = (): void => {
      const { match } = this.props
      const { params } = match
      const { resource, flyerId, resourceId } = params

      const context = {
        flyerId,
        districtId: resource === 'districts' ? resourceId : undefined,
        schoolId: resource === 'schools' ? resourceId : undefined
      }

      const data = {
        resource: metric,
        activity: 'clicked',
        source: 'web',
        eventDate: Date.now(),
        userAgent: window.navigator.userAgent,
        context
      }

      const v2MetricsData = {
        flyerIds: [flyerId],
        district:
          // eslint-disable-next-line no-nested-ternary
          context.districtId
            ? typeof context.districtId === 'string'
              ? context.districtId
              : context.districtId.toString()
            : null,
        school:
          // eslint-disable-next-line no-nested-ternary
          context.schoolId
            ? typeof context.schoolId === 'string'
              ? context.schoolId
              : context.schoolId.toString()
            : null,
        action: metric,
        eventTime: moment().format(),
        distributionId: 1,
        userAgent: window.navigator.userAgent,
        featureId,
      }
      Metric.postOne({ body: data })
      Metric.postMetrics({ body: v2MetricsData })
    }

    render() {
      const props = { ...this.props, onClick: this.onClick }
      return <WrappedComponent {...props} />
    }
  }
  WithMetricClick.displayName = `WithMetricClick(${getDisplayName(
    WrappedComponent
  )})`
  return metric ? withRouter(WithMetricClick) : WrappedComponent
}

export default withMetricClick



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/withMetricClick.js